import React from 'react';
import ReactMarkdown from "react-markdown";
import LoadingComponent from "../Components/Loading";
import Markdown from "../Components/Markdown";
import Header from '../Components/Header';
import Footer from "../Components/Footer";
import {categoryToNewsType, lStrings} from "../Constants/Strings";
import {Link} from 'react-router-dom';
import {APIService, BrowserService} from "../util";

const Image = ({src, alt}) => {
    if (src.indexOf('http') !== -1) {
        return <img src={src} alt={alt || ''}/>;
    } else {
        const f = src.split('.');
        const filetype = f[f.length - 1].toLowerCase();
        const filename = src.slice(0, -1 * filetype.length - 1);
        const srcset =
            filename + "." + filetype + " 1x, " +
            filename + "@2x." + filetype + " 2x, " +
            filename + "@3x." + filetype + " 3x";
        return (
            <img src={src} srcSet={srcset} alt={alt || ''}/>
        )
    }
};


class NewsDetail extends Markdown {

    loaded = false;

    constructor(props) {
        super(props);

        this.state.type = false;
        this.viewerRef = React.createRef();
    }

    componentDidMount() {
        this.load();
        this.renderViewer();
    }

    componentWillUnmount() {
        BrowserService.metaTag()
    }

    componentDidUpdate() {
        this.load();
        this.renderViewer();
    }

    renderViewer() {
        if (this.viewerRef && this.viewerRef.current) {
            if (this.viewer) {
                this.viewer.setMarkdown(this.state.markdown);
            } else {
                this.viewer = new window.toastui.Editor({
                    viewer: true,
                    el: this.viewerRef.current,
                    initialValue: this.state.markdown,
                    previewStyle: 'vertical',
                    height: 'auto',
                    usageStatistics: false,
                    useCommandShortcut: true,
                    linkAttributes: {
                        target: '_blank',
                        contenteditable: 'false',
                        rel: 'noopener noreferrer'
                    }
                });
            }
        }
    }

    load() {
        if (!this.loaded) {
            this.loaded = true;
            const params = this.props.match;
            const id = params.params.id;
            APIService.ownedMedia(id)
                .then(data => {
                    this.loaded = true;
                    this.makeMetaTag(data);
                    const locale = lStrings.getLanguage();
                    if (data.localization && locale !== 'ja') {
                        for (const loc of data.localization) {
                            if (loc.locale === locale) {
                                data.title = loc.title;
                                data.text = loc.text;
                                data.externalLink = loc.externalLink;
                                break;
                            }
                        }
                    }
                    if (data.externalLink && data.externalLink !== 'about:blank') {
                        window.location.replace(data.externalLink);
                    } else {
                        const category = categoryToNewsType(data.category);
                        this.setState({
                            title: data.title,
                            markdown: data.text,
                            categoryClass: category.class,
                            categoryText: category.text,
                            dateText: window.moment(data.date, 'YYYY-MM-DD').format('MMMM D, YYYY'),
                            loading: false,
                            type: 2
                        });
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        }
    }

    makeMetaTag(news) {
        if (news.uid) {
            if (!news.description) {
                BrowserService.addNoIndex();
                return
            }
            const seoData = {
                title: news.title.replaceAll('\n', ' '),
                text: news.description.replaceAll('\n', ' ')
            };
            if (news.image) {
                seoData.image = {
                    url: news.image.fileURL,
                    width: 1380,
                    height: 810
                };
            }
            BrowserService.metaTag(seoData);
        } else {
            if (!news.text) {
                BrowserService.addNoIndex();
                return
            }
            const seoData = {
                title: news.title.replaceAll('\n', ' '),
                text: news.text,
                image: {
                    url: new URL(window.location.origin + '/' + news.thumbnail).toString(),
                    width: 480,
                    height: 270
                }
            };
            try {
                const regexp = new RegExp(",\\s*([^\\s]+)\\s*3x", "g");
                const match = regexp.exec(news.thumbnailSet);
                if (match && match.length > 0) {
                    seoData.image.url = new URL(window.location.origin + '/' + match[1]).toString();
                    seoData.image.width = 1380;
                    seoData.image.height = 810;
                }
            } catch (e) {
                console.error(e);
            }
            BrowserService.metaTag(seoData);
        }
    }

    render() {
        return <div>
            <Header urlPrefix={'../'}/>
            <div className="container">
                <div className="row">
                    <div className="col-12 mb-5 markdown-render" id="l-news-detail">
                        {(() => {
                            if (this.state.loading) {
                                return <LoadingComponent/>
                            }
                            if (this.state.type === 2) {
                                return <div>
                                    <div className="news-header">
                                        <p className={'news-category-' + this.state.categoryClass}>{this.state.categoryText}</p>
                                        <h1 className="news-title">{this.state.title}</h1>
                                        <p className="news-date">{this.state.dateText}</p>
                                    </div>
                                    <div ref={this.viewerRef} id="toast-viewer"></div>
                                </div>
                            }
                            return <ReactMarkdown
                                source={this.state.markdown}
                                renderers={{image: Image}}
                                escapeHtml={false}/>
                        })()}
                    </div>
                    <div className="col-12 mb-5 pb-5">
                        <Link to="../news"
                              className="btn btn-outline-dark btn-more btn-block">{lStrings.news_back_to_list}</Link>
                    </div>

                </div>
            </div>

            <Footer/>
        </div>
    }
}


export default NewsDetail;



// WEBPACK FOOTER //
// ./src/News/NewsDetail.js